import Swiper from 'swiper/bundle';

export const carousel = () => {
  function setAlignFullCssVar() {
    // Create the measurement node
    let scrollDiv = document.createElement('div');
    scrollDiv.className = 'scrollbar-measure';
    document.body.appendChild(scrollDiv);

    // Get the scrollbar width & half width
    let scrollBarWidth = window.innerWidth - scrollDiv.clientWidth;
    let alignFullOffset = scrollBarWidth / 2;

    // console.log(window.innerWidth);
    // console.log(scrollDiv.clientWidth);
    // console.warn(scrollBarWidth); // Mac:  15

    // Delete the DIV
    document.body.removeChild(scrollDiv);

    //Get .alignfull element
    let root = document.documentElement;
    let root_style = getComputedStyle(root);

    //Set --alignfull-offset css var
    let cssVarAlignFullOffset =
      root_style.getPropertyValue('--alignfull-offset');
    if (alignFullOffset + 'px' !== cssVarAlignFullOffset) {
      root.style.setProperty('--alignfull-offset', alignFullOffset + 'px');
    }
  }
  //gallery sliders
  const swiperBlocks = document.querySelectorAll(
    '.is-style-carousel .wp-block-post-template',
  );

  const swiperInstances = [...swiperBlocks].map((block) => {
    const $block = $(block);

    // removes classes that starts with wp- & is-flex;
    $block.removeClass((_, css) => (css.match(/\bwp-\S+/g) || []).join(' '));
    $block.removeClass((_, css) =>
      (css.match(/\bis-flex\S+/g) || []).join(' '),
    );

    $block
      .addClass('wp-block-post-template swiper')
      .children()
      .addClass('swiper-slide')
      .wrapAll('<div class="swiper-wrapper">');

    $block
      .append(
        '<div class="swiper-button-prev swiper-button"><?xml version="1.0" encoding="UTF-8"?><svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg"><path d="m477.91 600 16.77 19.602 181.37 211.6 46.051-39.203-164.6-192 164.6-192-46.051-39.203-181.37 211.6-16.77 19.602z" fill="#fff"/></svg>',
      )
      .append(
        '<div class="swiper-button-next swiper-button"><?xml version="1.0" encoding="UTF-8"?><svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg"><path d="m722.1 600-16.766-19.602-181.37-211.6-46.051 39.203 164.61 192-164.61 192 46.051 39.203 181.37-211.6z" fill="#fff"/></svg>',
      );

    const instance = new Swiper(block, {
      loop: true,
      slidesPerView: 'auto',
      autoHeight: true,
      speed: 800,
      // loopedSlides: 8,
      disableOnInteraction: true,
      autoplay: {
        delay: 2400,
      },
      breakpoints: {
        // when window width is >= 1080px
        1080: {
          // allowTouchMove: false,
        },
      },
      // freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function () {
          // console.log('custom'); // this works
          //setAlignFullCssVar();
        },
        imagesReady: function () {
          setAlignFullCssVar();
        },
      },
    });

    return instance;
  });

  swiperInstances.forEach((swiper) => {
    $(swiper.wrapperEl).mouseenter(function () {
      swiper.autoplay.stop();
    });
    $(swiper.wrapperEl).mouseleave(function () {
      swiper.autoplay.start();
    });
    // $(swiper.wrapperEl)
    //   .closest('.wp-block-query')
    //   .find('.project-filters a')
    //   .click(function () {
    //     swiper.updateSlides();
    //   });
  });
};
